export interface IRegistrationToken {
    value: string;
}

export class RegistrationToken implements IRegistrationToken {
    constructor(
        public value: string
    ) { }
}
